// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import CommonModal from 'components/uiKit/CommonModal';
import Button from 'components/uiKit/Button';
import Status, {
  CompanyStatus,
  CompanyStatusArray,
  AOStatusArrayForced,
  CompanyStatusToName,
} from 'components/common/Status';
import { DropdownKit, DropdownSizeEnum } from 'components/uiKit/DropdownKit';

import styles from './styles.module.scss';

type Props = {
  isCompany?: boolean;
  onClose: () => void;
  isOpen: boolean;
  handleConfirmClick: (newStatus: CompanyStatus) => void;
  currentStatus: CompanyStatus;
  tax?: boolean;
};

const ChangeAOStatusForcedModal: FC<Props> = ({
  isOpen,
  onClose,
  handleConfirmClick,
  currentStatus,
  isCompany = false,
  tax,
}) => {
  const [newStatus, setNewStatus] = useState<CompanyStatus>();
  const { t } = useTranslation();

  useEffect(() => {
    setNewStatus(currentStatus);
  }, []);

  return (
    <CommonModal
      open={isOpen}
      onClose={onClose}
      title={t('company.changeStatusForced')}
      actions={
        <Button onClick={() => handleConfirmClick(newStatus)} variant="fill" disabled={currentStatus === newStatus}>
          {t('company.saveStatus')}
        </Button>
      }
    >
      <div className={styles.dropdownWrapper}>
        <DropdownKit
          required
          label={t('company.status')}
          options={AOStatusArrayForced}
          positionType={DropdownSizeEnum.SIZE_60}
          wrapStyle={isCompany ? { width: '245px' } : { width: '343px' }}
          isHiddenMenuAll
          changeSelectItem={(_e, data) => setNewStatus(data)}
          value={CompanyStatusToName[newStatus]}
          customOption={(status: CompanyStatus, _isActive, handleMouseDown) => (
            <div className={styles.dropdownItem} onClick={handleMouseDown}>
              <Status status={status} className={styles.dropdownStatus} />
            </div>
          )}
        />
        <div className={styles.warningText}>Status will changed without check</div>
      </div>
    </CommonModal>
  );
};

export default ChangeAOStatusForcedModal;

